import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { DashboardDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpDashboardService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/dashboard');
	}

	getDashboard(): Observable<DashboardDto> {
		return super.get(`/get`);
	}
}
